import { getRandomInt } from '~/bootcamp/Activities/Fractions/Fractions.utils'

interface RangeModel {
  numerator: { min: number; max: number }
  denominator: { min: number; max: number }
  variation: number
}

interface DifficultyLevelRangeMapModel {
  [key: number]: RangeModel
}

export interface FractionModel {
  quotient: number
  numerator: number
  denominator: number
}

export interface FractionImproperToMixedQuestionModel {
  question: FractionModel
  answer: FractionModel
  maxVariation: number
}

const DIFFICULTY_LEVEL_RANGE_MAP: DifficultyLevelRangeMapModel = {
  1: { numerator: { min: 2, max: 26 }, denominator: { min: 2, max: 5 }, variation: 80 },
  2: { numerator: { min: 5, max: 61 }, denominator: { min: 5, max: 20 }, variation: 600 },
  3: { numerator: { min: 10, max: 301 }, denominator: { min: 10, max: 50 }, variation: 1000 },
}

function improperToMixed({ numerator, denominator }: FractionModel): FractionModel {
  return { quotient: Math.floor(numerator / denominator), numerator: numerator % denominator, denominator }
}

function generateGCD(number1: number, number2: number): number {
  if (number1 === 0) return number2
  return generateGCD(number2 % number1, number1)
}

export function getFractionImproperToMixedQuestionData(
  difficultyLevel: number,
  excludeFrac: string[],
): FractionImproperToMixedQuestionModel {
  const excludes = new Set(excludeFrac)
  const range = DIFFICULTY_LEVEL_RANGE_MAP[difficultyLevel]
  let denominator = 1
  let numerator = 1
  // eslint-disable-next-line fp/no-loops
  while (numerator % denominator === 0) {
    denominator = getRandomInt(range.denominator.min, range.denominator.max)
    numerator = getRandomInt(denominator + 1, range.numerator.max)
  }
  const gcd = generateGCD(denominator, numerator)
  denominator = denominator / gcd
  numerator = numerator / gcd
  const question: FractionModel = { numerator, denominator, quotient: 0 }
  const answer: FractionModel = improperToMixed(question)

  if (excludes.has(`${question.numerator}-${question.denominator}`)) {
    return getFractionImproperToMixedQuestionData(difficultyLevel, excludeFrac)
  }
  return { question, answer, maxVariation: range.variation }
}
